import { render, staticRenderFns } from "./AddGroupDocSetting.vue?vue&type=template&id=1e0a4b6a&"
import script from "./AddGroupDocSetting.vue?vue&type=script&lang=js&"
export * from "./AddGroupDocSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports